import updateAttachmentGroupInput from './update-attachment-group-input'

export default function (element) {
  const $exportAttachmentInput = element
    .closest('tr')
    .find('.export-attachment input')
  const checked = $exportAttachmentInput.prop('checked')
  const groupUid = element
    .closest('table')
    .find('[data-behaviour="export-check-group-name"]')
    .attr('uid')
  const section = element.closest('[data-behaviour="export-element"]')

  return section
    .find(`input#${$exportAttachmentInput.attr('id')}`)
    .each(function () {
      if (
        groupUid !==
        $(this)
          .closest('table')
          .find('[data-behaviour="export-check-group-name"]')
          .attr('uid')
      ) {
        $(this).prop('checked', checked)
        return updateAttachmentGroupInput($(this).closest('table'))
      }
    })
}
